export default __webpack_public_path__ + "static/tecalis-students_02-df782563ac337bca057c2110ba8cbdbd.png";